module.exports = __webpack_public_path__ + "static/media/innerLogo.c75a544c.png";